import React from 'react';

export interface DateEditorProps {
  dates: Date[];
}

export const DateList: React.FC<DateEditorProps> = ({ dates }) => {
  if (dates.length === 0) return <></>;

  const formatDate = (d: Date): string => {
    const [year, month, day] = d.toISOString().slice(0, 10).split('-');
    return `${day}.${month}.${year}`;
  };

  const formattedDates = dates.map(formatDate);

  return (
    <div>
      <p className="font-size--medium">{formattedDates.join(', ')}</p>
    </div>
  );
};

export default DateList;
